module.exports = __webpack_public_path__ + "media/dawn-promo.d5783da2.mp4";